import { render, staticRenderFns } from "./AddNewConversationColumn.vue?vue&type=template&id=291a9c3e&scoped=true&"
import script from "./AddNewConversationColumn.vue?vue&type=script&lang=js&"
export * from "./AddNewConversationColumn.vue?vue&type=script&lang=js&"
import style0 from "./AddNewConversationColumn.vue?vue&type=style&index=0&id=291a9c3e&lang=less&scoped=true&"
import style1 from "./AddNewConversationColumn.vue?vue&type=style&index=1&id=291a9c3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291a9c3e",
  null
  
)

export default component.exports